module.exports = {
  "acq-129": {
    "identifierType": "UTK",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variant_a"
      ]
    }
  },
  "acqci-acq-130": {
    "identifierType": "UTK",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variant_a",
        "variant_b"
      ]
    }
  },
  "acqci-acq-131": {
    "identifierType": "UTK",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variant_a",
        "variant_b",
        "variant_c",
        "variant_d"
      ]
    }
  },
  "biab-004": {
    "identifierType": "PORTAL_ID",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variant"
      ]
    }
  },
  "acq-128": {
    "identifierType": "UTK",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variant_a"
      ]
    }
  }
};